import { useEffect, useState } from "react";
import { Users } from "lucide-react";
import api from "@/lib/api";
import { PageHeader } from "@/components/ui-helpers";

export default function SellerCustomers() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/marketplace/seller/customers").then((r) => setItems(r.data.customers || [])).catch(() => setItems([])); }, []);

  return (
    <div data-testid="seller-customers-page">
      <PageHeader title="Customers" icon={Users} subtitle="Customers who have ordered from your store. Only data needed for fulfilment is shown." />
      {items && items.length === 0 && <div className="rounded-2xl border border-dashed border-slate-300 bg-white p-12 text-center text-sm text-slate-500" data-testid="customers-empty">No customers yet.</div>}
      <div className="overflow-hidden rounded-2xl border border-slate-200 bg-white" data-testid="customers-list">
        {(items || []).map((c, i) => (
          <div key={i} className="flex items-center justify-between gap-3 border-b border-slate-100 p-3 last:border-0" data-testid={`cust-${i}`}>
            <div><p className="text-sm font-medium text-slate-800">{c.name}</p><p className="text-xs text-slate-400">{c.orders} order{c.orders > 1 ? "s" : ""}{c.last_order ? ` · last ${new Date(c.last_order).toLocaleDateString()}` : ""}</p></div>
            <span className="text-sm font-bold text-slate-800">₹{Math.round(c.spent).toLocaleString("en-IN")}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
